<template>
  <teleport to="body">
    <transition-group class="message-container" name="message" tag="div">
      <div v-for="item in messages" :key="item.id" class="message-bg">
        <div class="message" :class="`message--${item.type}`">
          <i class="message__icon t-iconfont" :class="iconMap[item.type]"></i>
          <span class="message__text" style="margin-left: 8px">{{ item.text }}</span>
        </div>
      </div>
    </transition-group>
  </teleport>
</template>

<script setup>
import { ref } from 'vue'

const messages = ref([])
let seed = 0

const iconMap = {
  success: 'icon-checkbox-circle-fill',
  warning: 'icon-error-warning-fill',
  error: 'icon-close-circle-fill',
  info: 'icon-information-fill'
}

const add = (text, type = 'info', duration = 3000) => {
  const id = ++seed
  messages.value.push({ id, text, type })
  if (duration > 0) {
    setTimeout(() => remove(id), duration)
  }
}

let onEmptyCallback = null

const remove = (id) => {
  const index = messages.value.findIndex((m) => m.id === id)
  if (index !== -1) messages.value.splice(index, 1)
  if (messages.value.length === 0 && onEmptyCallback) {
    onEmptyCallback()
  }
}

const setOnEmpty = (fn) => {
  onEmptyCallback = fn
}

defineExpose({ add, setOnEmpty })
</script>

<style lang="less" scoped>
.message-container {
  position: fixed;
  // 原生 App 的状态栏高度与浏览器安全区取较大值，避免重复累加。
  top: calc(20px + max(var(--status-bar-height, 0px), env(safe-area-inset-top, 0px)));
  left: 50%;
  transform: translateX(-50%);
  z-index: 9999;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  pointer-events: none;
}

.message-bg {
  display: flex;
  align-items: center;
  border-radius: 12px;
  // background: linear-gradient(291deg, #1574ff 2%, #5952ff 51%, #a969fe 96%);

  box-shadow: 0px 2px 30px 2px rgba(0, 0, 0, 0.2);
  overflow: hidden;
  // padding: 1px;
}

.message {
  display: inline-flex;
  align-items: center;
  padding: 10px 16px;
  border-radius: 12px;
  font-size: 14px;
  line-height: 1.5;
  background: #fff;
  pointer-events: auto;
  white-space: nowrap;

  &--success {
    color: #07c160;
    .message__icon {
      color: #07c160;
    }
  }

  &--warning {
    color: #ff976a;
    .message__icon {
      color: #ff976a;
    }
  }

  &--error {
    color: #ee0a24;
    .message__icon {
      color: #ee0a24;
    }
  }

  &--info {
    color: #248df5;
    .message__icon {
      color: #248df5;
    }
  }
}

.message__text {
  font-family: PingFang SC;
  font-size: 14px;
  font-weight: normal;
  line-height: 20px;
  color: #323233;
}

.message-enter-active,
.message-leave-active {
  transition: all 0.3s ease;
}

.message-enter-from {
  opacity: 0;
  transform: translateY(-12px);
}

.message-leave-to {
  opacity: 0;
  transform: translateY(-8px);
}
</style>
